import ko from 'knockout'
import { ProvDivsViewModel, ProvDivsViewModelParams } from './ProvDivsViewModel'
import template from './prov-divs.tpl.html'

if (!ko.components.isRegistered('prov-divs')) {
  ko.components.register('prov-divs', {
    viewModel: {
      createViewModel: (params: ProvDivsViewModelParams) => {
        const viewModel = new ProvDivsViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
